(function($) {
  $(document).ready(function(){


    // Replace all SVG images with inline SVG
    $('img.svg').each(function(){
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function(data) {
        var $svg = $(data).find('svg');
        if(typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if(typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass+' replaced-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');

        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
        }
        $img.replaceWith($svg);
      }, 'xml');
    });

    // Home page titles
    $('.slick-home').slick({
      dots: true,
      infinite: true,
      speed: 400,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false
          }
        }
      ]
    });


    // CF7 fix
    $('.wpcf7 br').remove();

    // Brand page structure
    $('.page_brands .brands_subcategories li a').each(function(){
      var letterCharacter = $(this).attr('data-letter');

      $('.page_brands .brands_subcategories li a[data-letter="'+ letterCharacter +'"]').each(function(){
        $(this).appendTo( $('.page_brands .inner div[data-letter="'+ letterCharacter +'"]') );
      });
    });

    // Woocommerce inputs
    $('.woocommerce-account .input-text').addClass('form-control');
    $('.woocommerce-checkout .input-text').addClass('form-control');

    $('.woocommerce-checkout .input-text').each(function(){
      $(this).prev( $('abbr').remove() );
      var inputPlaceholder = $(this).prev().html();
      $(this).attr('placeholder', inputPlaceholder + '*');
    });
    $('#order_comments_field #order_comments').attr('placeholder', 'Nazwa firmy, adres, NIP...')

    //
    $('footer ul.menu li a').prepend('<span>&raquo;</span>');

    // page sell steps
    $('.page_sell .info_row:nth-child(even)').each(function(){
      $('.page_sell .info_row:nth-child(even) [class*="col-"]:nth-child(1)').addClass('col-sm-push-10');
      $('.page_sell .info_row:nth-child(even) [class*="col-"]:nth-child(3)').addClass('col-sm-pull-10');
    });

    // page faq
    $('.page_faq .panel-group .panel:first-child() .panel-collapse').addClass('in');
    $('.page_faq .panel-group .panel:first-child() .panel-heading a').removeClass('collapsed');

    // sidebar select
    $('.widget select').wrap('<div class="select_wrapper"></div>');

    // Sell form
    $('.page_sell .wpcf7 #additionalSell').click(function(){
      if( $(this).hasClass('click3') ){
        $(this).addClass('disabled');
        $('#sellItem5').css('display', 'block');
      } else if( $(this).hasClass('click2') ){
        $(this).addClass('click3');
        $('#sellItem4').css('display', 'block');
      } else if( $(this).hasClass('click1') ){
        $(this).addClass('click2');
        $('#sellItem3').css('display', 'block');
      }
      $(this).addClass('click1');
      $('#sellItem2').css('display', 'block');
    });

  });
})(jQuery);



